import React, {useEffect, useState} from 'react';
import { Avatar } from 'antd';
import { Link } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import Cookies from 'js-cookie';
import { InfoWraper, NavAuth, UserDropDwon } from './auth-info-style';
import Message from './message';
import Notification from './notification';
import Settings from './settings';
import Support from './support';
import { Popover } from '../../popup/popup';
import { Dropdown } from '../../dropdown/dropdown';
import { logOut } from '../../../redux/authentication/actionCreator';
import Heading from '../../heading/heading';

const AuthInfo = () => {
  const dispatch = useDispatch();
  //const [user, setUser] = useState(null);
  const user = useSelector(state => state.auth.user);

  const SignOut = e => {
    e.preventDefault();
    dispatch(logOut());
  };

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <figure className="user-dropdwon__info">
          { /*<img src={require('../../../static/img/auth/account_icon_black.png')} width="46" alt="" /> */ }
          <figcaption>
            <Heading as="h5">{user?.nombreEmpleado}</Heading>
            <p>Sucursal: <strong>{user?.nombreSucursal}</strong></p>            
          </figcaption>
        </figure>
        <ul className="user-dropdwon__links">
          <li>
            <Link to="#">
              <FeatherIcon icon="user" /> Mi perfil
            </Link>
          </li>
          <li>
            <Link to="#">
              <FeatherIcon icon="bell" /> Soporte
            </Link>
          </li>
        </ul>
        <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
          <FeatherIcon icon="log-out" /> Cerrar sesión
        </Link>
      </div>
    </UserDropDwon>
  );


  return (
    <InfoWraper>
      <div className="nav-author">
        <Popover placement="bottomRight" content={userContent} action="click">
          <Link to="#" className="head-example">
            <Avatar src={require('../../../static/img/auth/account_icon_white.png')} />
          </Link>
        </Popover>
      </div>
    </InfoWraper>
  );
};

export default AuthInfo;
